export const ACCEPT = 'ACCEPT';
export const DECLINE = 'DECLINE';
export const ACCEPTED = 'ACCEPTED';
export const DECLINED = 'DECLINED';
export const ALL = 'ALL';
export const PENDING = 'PENDING';

